import { render } from "./contract_info.vue?vue&type=template&id=636c7a78&scoped=true"
import script from "./contract_info.vue?vue&type=script&lang=js"
export * from "./contract_info.vue?vue&type=script&lang=js"

import "./contract_info.vue?vue&type=style&index=0&id=636c7a78&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636c7a78"]])

export default __exports__